<template>
    <div class="inner-box">
        <!-- <div class="content-name">
            <h2 class="dp-ib">{{ routeName }}</h2>
        </div> -->
        <div class="search-area2">
            <div>
                <search-form ref="refSearchForm" :search="search" />
            </div>
        </div>
        <!-- <button @click="next">{{$refs.step}}다음</button>
        <Step ref="steps" :active="nextIdx" :steps="steps"></Step> -->
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam"/>

        <!--공통-->
        <input id="hddTemp"                 type="hidden" v-model="com.hddTemp" /><!--외부 정보를 전달하기 위한 임시 공간-->
        <input id="hddCustSelectable"       type="hidden" v-model="com.hddCustSelectable" />
        <input id="hddFocusControlId"       type="hidden" v-model="com.hddFocusControlId" />
        <input id="hddSelectedTabClientID"  type="hidden" v-model="com.hddSelectedTabClientID" />
        <input id="hddFocusControlClientId" type="hidden" v-model="com.hddFocusControlClientId" />
        <input id="hddCustFindControlId"    type="hidden" v-model="com.hddCustFindControlId" />
        <input id="hddBOUND_ID"             type="hidden" v-model="com.hddBoundId" />
        <input id="hddEditable"             type="hidden" v-model="com.hddEditable" />
        <input id="hddCALL_BOUND_ID"        type="hidden" v-model="com.hddCallBoundId" /><!--콜이입시의 바운드아이디(내부)-->
        
        <!--일반상담-->
        <input id="hddCALL_ID"             type="hidden" v-model="com.hddCallId" />
        <input id="hddCAT_ID_LEVEL"        type="hidden" v-model="com.hddCallIdLevel" />
        <input id="hddCallTab_MODEL_ID"    type="hidden" v-model="com.hddCallTabModelId" />
        <input id="hddCallTab_MAKER"       type="hidden" v-model="com.hddCallTabMaker" />
        <input id="hddCallTab_MODEL_GROUP" type="hidden" v-model="com.hddCallTabModelGroup" />
        <input id="hddCallTab_MODEL_CD"    type="hidden" v-model="com.hddCallTabModelCd" />
        <input id="hddCallTab_DEPT_ID"     type="hidden" v-model="com.hddCallTabDeptCd" />
        <input id="hddCallTab_CHARGE_ID"   type="hidden" v-model="com.hddCallTabChargeId" />
        <input id="hddCallTab_CALL_TYPE"   type="hidden" v-model="com.hddCallTabCallType" />

        <!--주문상담-->
        <input id="hddORDER_ID"            type="hidden" v-model="com.hddOrderId" />
        <input id="hddOrderTab_PAY_YN"     type="hidden" v-model="com.hddOrderTabPayYn" />
    </div>
</template>

<script>

/* TEST */
import Step from '@/components/elementUI/Step/index.vue';
//import Views from '@/components/AS/Step/index.vue';

/* 검색 폼 컴포넌트 */
import SearchForm from '@/components/AS/AgentList/agentListSearchForm.vue';
/* Tab 구분 컴포넌트 */
import tabs from '@/components/AS/Tabs/index.vue';
import subTab1 from '@/components/AS/AgentList/subTab1.vue';
import subTab2 from '@/components/AS/AgentList/subTab2.vue';
import subTab3 from '@/components/AS/AgentList/subTab3.vue';

export default {
    components: {Step, SearchForm, tabs, subTab1, subTab2, subTab3},
    data() {
        return {
            drawer: false,
            direction: 'ttb',
            data: [],
            viewer: 'subTab1',
            orgTab:[
                {tabId: 'subTab1', tabName:'기본정보', tabCss:"btn btn-primary", tabNo:'0', tabShow: true},
                {tabId: 'subTab2', tabName:'기사정보', tabCss:"btn btn-outline-primary", tabNo:'1', tabShow: true},/** 'btn btn-nonActive'버튼 비활성화 class */
                {tabId: 'subTab3', tabName:'근무시간표', tabCss:"btn btn-outline-primary", tabNo:'2', tabShow: true}
            ],
            tab:[],
            search: {
                custNm: "",
                custId: "",
                custType: "",
                custGb: "1",
                codeNm: "",
                useType: "Y",
                inType: "", /** 유입경로 */
                inTypeVal: "" /** 유입경로 값*/
            },
            com : {
                hddTemp: '',
                hddCustSelectable: '',   
                hddFocusControlId: '',   
                hddSelectedTabClientID: '',  
                hddFocusControlClientId: '',
                hddCustFindControlId: '',
                hddBoundId: '',         
                hddEditable: '',         
                hddCallBoundId: '0', /** 콜이입시의 바운드아이디(내부) */

                hddCallId: '',
                hddCallIdLevel: '',
                hddCallTabModelId: '',
                hddCallTabMaker: '',
                hddCallTabModelGroup: '',
                hddCallTabModelCd: '',
                hddCallTabDeptCd: '',
                hddCallTabChargeId: '',
                hddCallTabCallType: '',

                hddOrderId: '',
                hddOrderTabPayYn: ''
            },
            active: true,
            nextIdx: 1,
            steps: [{
                title: 'Step 1'
                ,description: ''
            },
            {
                title: 'Step 2'
                ,description: ''
            },
            {
                title: 'Step 3'
                ,description: ''
            }],
            grants: {},
            custParam:{},
            inType: '', /** 유입경로 */
            inTypeVal: '' /** 유입경로 값 */
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        getGrants() {
            const {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate} = this.$menu.getGrants();
            return {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate}
        }
    },
    created() {
        this.tab = _.cloneDeep(this.orgTab);

        this.$store.commit("setHeaderTitle", {
            headerComponentName: this.head,
            routeName: this.routeName,
            isMobile: this.$device.isMobile()
        });
    },
    mounted() {
        this.grants = this.$menu.getGrants();

        const rqInboundTelNo = this.$route.query.InboundTelNo ? this.$route.query.InboundTelNo : '' // 전화가 인입됨
        const rqUserId = this.$route.query.UserId ? this.$route.query.UserId : '' // USER_ID
        const rqCALL_ID = this.$route.query.CALL_ID ? this.$route.query.CALL_ID : ''    // CALL_ID
        const rqAS_ID = this.$route.query.AS_ID ? this.$route.query.AS_ID : ''    // AS_ID
        const rqORDER_ID = this.$route.query.ORDER_ID ? this.$route.query.ORDER_ID : ''    // ORDER_ID
        const rqReservationId = this.$route.query.ReservationId ? this.$route.query.ReservationId : ''    // ReservationId
        const rqRequestId = this.$route.query.RequestId ? this.$route.query.RequestId : ''    // RequestId
        const rqCallbackId = this.$route.query.CallbackId ? this.$route.query.CallbackId : ''    // CallbackId

        this.inType = '' // 유입경로
        this.inTypeVal = ''
        if(rqInboundTelNo != ''){
            this.inType = 'IN_BOUND'
            this.inTypeVal = rqInboundTelNo
            
        } else if(rqUserId != ''){
            // 기존 고객아이디로 재통화 - 팝업으로 메인창 오픈 : location.href = "../Call/CallMain.aspx?UserId=" + userId;
            this.inType = 'IN_USER_ID'
            this.inTypeVal = rqUserId
        
        } else if(rqCALL_ID != ''){
            // 기존 일반상담이력 수정(조회)
            this.inType = 'IN_CALL_ID'
            this.inTypeVal = rqCALL_ID

        } else if(rqAS_ID != ''){
            // 기존 AS상담이력 수정(조회)
            this.inType = 'IN_AS_ID'
            this.inTypeVal = rqAS_ID
        
        } else if(rqORDER_ID != ''){
            // 기존 주문상담이력 수정(조회)
            this.inType = 'IN_ORDER_ID'
            this.inTypeVal = rqORDER_ID
        
        } else if(rqReservationId != ''){
            // 예약상담
            this.inType = 'IN_RESERVATION_ID'
            this.inTypeVal = rqReservationId
        
        } else if(rqRequestId != ''){
            // 기존 BsMa이력 수정(조회) OR 기존 설치이력 수정(조회)
            this.inType = 'IN_REQUEST_ID'
            this.inTypeVal = rqRequestId
        
        } else if(rqCallbackId != ''){
            this.inType = 'IN_CALLBACK_ID'
            this.inTypeVal = rqCallbackId
        }

        this.search.inType = this.inType
        this.search.inTypeVal = this.inTypeVal

        this.search = {
            ...this.com,
            ...this.search
        }

        if(this.search.inType != ''){
            if(this.inType === 'IN_CALL_ID'){
                this.viewer = 'subTab3';
                
                this.tab[0].tabCss = 'btn btn-outline-primary';
                this.tab[1].tabCss = 'btn btn-outline-primary';
                this.tab[2].tabCss = 'btn btn-primary';
                this.tab[3].tabCss = 'btn btn-outline-primary';

                this.tab[0].tabShow = false; // AS접수
            } else {
                this.viewer = 'subTab1';

                this.tab[0].tabCss = 'btn btn-primary';
                this.tab[1].tabCss = 'btn btn-outline-primary';
                this.tab[2].tabCss = 'btn btn-outline-primary';
                this.tab[3].tabCss = 'btn btn-outline-primary';

                this.tab[0].tabShow = true; // AS접수
            }

            
            console.log('this.$refs.refSearchForm: ', this.viewer, this.$refs.refSearchForm)
            //주의: mount 시점 차이로 인해서 refs로는 값이 셋팅할 수 없어서 pObj로 값을 셋팅함.
            const pObj = {
                inType: this.inType,
                inTypeVal: this.inTypeVal
            }
            this.$refs.refSearchForm.goOpen('', pObj)
        }
    },
    methods: {
        save() {
            
        },
        changeTab(params) {
            this.viewer = params.tabId;
        },
        searchContentInTab(param){
            /**
             * 현재 뷰내의 자식콤포넌트인 SearchForm에서 DB데이타를 조회하여
             *  활성화된 자식콤포넌트(subTab1, subTab2, subTab3)의 data에 값을 셋팅처리
             */

            // this.histList = param.callAsCustSelPageList || []
            // this.custInfo = param.callCustSelItemList || {}
            console.log(' cmpTab ref: ', this.$refs.cmpTab)
            this.custParam = {
                ...param
             } || {}

            if(this.viewer === 'subTab1') {
                this.$refs.cmpTab.setNormalList(param.tab1AsAgentSelItem || {});
            } else if(this.viewer === 'subTab2') {
                this.$refs.cmpTab.setNormalList(param.tab2ServiceEngineerSelAgent || []);
            } else if(this.viewer === 'subTab3') {
                console.log('this.viewer 3: ', param.tab3AsAgentSelItem, param);
                this.$refs.cmpTab.setNormalList(param.tab3AsAgentSelItem || []);
            }
        },
        handleClose(done) {
            this.$confirm('Are you sure you want to close this?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        next() {
            console.log('AsMng next() start')
            if (this.nextIdx++ > this.steps.length-1) {
                this.nextIdx = 1;
            }
            //console.log(this.$refs.steps.$refs)
            if(this.nextIdx === 1) {
                console.log(`step1`,this.$refs.steps.$refs.step3)
            } else if(this.nextIdx === 2) {
                console.log(`step2`, this.$refs.steps.$refs.step1)
            } else if(this.nextIdx === 3) {
                console.log(`step3`, this.$refs.steps.$refs.step2)
            }
            return this.nextIdx;
        }
    }
}
</script>